import blocks, { RawBlockType, rawBlockTypeToBlockType } from "@/components/PowerBlock/Blocks";

interface NodeTypeIconProps {
  type: RawBlockType;
  backgroundColor: string;
  textColor: string;
}
const NodeTypeIcon: React.FC<NodeTypeIconProps> = ({ type, backgroundColor, textColor }) => {
  const TypeIcon = blocks[rawBlockTypeToBlockType(type)]?.icon;
  if (!TypeIcon) {
    return null;
  }
  return (
    <TypeIcon
      className={`h-6 w-6 rounded-full ${backgroundColor} p-1 ${textColor} transition-all duration-300 ease-in-out`}
    />
  );
};

export default NodeTypeIcon;
